<template>
    <section class="content">
        <div class="row center-block">
            <div class="col-md-12">
                <div class="box">
                    <div class="box-header">
                        <!--<h3 class="box-title">Data Table With Full Features</h3>-->
                    </div>
                    <!-- /.box-header -->
                    <div class="box-body">
                        <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div id="example1_length" class="dataTables_length">

                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                                        <thead>
                                        <tr role="row">
                                            <th> </th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Driver License</th>
                                            <th>Taxi Plate</th>
                                            <th>Phone</th>
                                            <th>Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <th colspan="1" rowspan="1"> </th>
                                            <th colspan="1" rowspan="1">Name</th>
                                            <th colspan="1" rowspan="1">Email</th>
                                            <th colspan="1" rowspan="1">Driver License</th>
                                            <th colspan="1" rowspan="1">Taxi Plate</th>
                                            <th colspan="1" rowspan="1">Phone</th>
                                            <th colspan="1" rowspan="1">Action</th>
                                        </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- /.box-body -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
  import $ from 'jquery'

  // Require needed datatables modules
  require('datatables.net')
  require('datatables.net-bs')
  module.exports = {
    name: 'Tables',
    data: function () {
      return {
        showModal: false
      }
    },
    mounted: function () {
      const state = this.$store.state
      var store = this.$store
      const self = this
      //state.serverURI + 'api/a/driver-list'
      this.$nextTick(function () {
        $('#example1 tbody').on( 'click', 'a', function () {
          if($(this).attr('class') =="edit"){
            self.driverEdit($(this).attr('id'))
          }else if($(this).attr('class') =="delete"){
            self.driverDelete($(this).attr('id'))
          }
        })
        $('#example1').DataTable({
          'processing': true,
          'serverSide': true,
          'aaSorting': [[1, 'asc']],
          "ajax": {
            "url": state.serverURI + 'api/a/driver-list',
            "dataType": 'json',
            "type": "GET",
            "beforeSend": function(xhr){
              xhr.setRequestHeader("Authorization",
                'fb ' + state.user.id + ' ' + state.token );
            },
            'error': function ($xhr) {
              if ($xhr.status === 401) {
                store.dispatch('doSetToken', null )
                store.dispatch('doSetUser', null )

                if (window.localStorage) {
                  window.localStorage.removeItem('user')
                  window.localStorage.removeItem('token')
                }
                self.$router.push( '/login' )
              }
            }
          },
          "columnDefs": [
            {
              "render": function ( data, type, row ) {
                return '<img src="'+data+'" style="width=300px;height=300px;" />';
              },
              "targets": 0 ,// column index
              "bSortable": false,
            },{
              "render": function ( data, type, row ) {
                return '<a href="javascript:;" class="edit" id="'+data+'" ><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a><span>&nbsp;&nbsp;</span><a href="javascript:;" class="delete" id='+ data +' ><i class="fa fa-times" aria-hidden="true"></i></a>';
              },
              "targets": -1 ,// column index
              "bSortable": false,
            }
          ]
        })
      })
    },
    methods:{
      driverEdit: function (fbid) {
        const self = this
        self.$router.push({name : 'Driver Edit' , params : {fbid:fbid}});
      },
      driverDelete:function (fbid) {
        const self = this
        self.$router.push({name : 'Driver Delete' , params : {fbid:fbid}});
      }
    }
  }
</script>

<style>
    /* Using the bootstrap style, but overriding the font to not draw in
       the Glyphicons Halflings font as an additional requirement for sorting icons.

       An alternative to the solution active below is to use the jquery style
       which uses images, but the color on the images does not match adminlte.

    @import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
    */

    @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

    table.dataTable thead .sorting:after, table.dataTable thead .sorting_asc:after, table.dataTable thead .sorting_desc:after {
        font-family: 'FontAwesome';
    }

    table.dataTable thead .sorting:after {
        content: "\f0dc";
    }

    table.dataTable thead .sorting_asc:after {
        content: "\f0dd";
    }

    table.dataTable thead .sorting_desc:after {
        content: "\f0de";
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 300px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>



// WEBPACK FOOTER //
// DriverList.vue?317307a2